import React from "react";
import Separator from "@/components/Misc/Separator";
import TestimonialsCard from "@/components/Testimonials/TestimonialsCard";
import s from "@/components/Misc/Separator.module.scss";
import styles from "@/components/Testimonials/Testimonials.module.scss";
import cn from "@/utils/classNames.js";
import { useTemplateStore } from "@/zustand/templateStore.js";

const TestimonialsList = () => {
  const isEnhancedContrast = useTemplateStore((state) => state.enhancedContrast);

  return (
    <>
      <Separator
        text={window.post_template.checkout_v6_testimonials.tr_checkout_v6_testimonials_section_title}
        margin="24px 0px 16px"
        dataTestid="testimonials-title"
        mainClass={cn(s.separator, isEnhancedContrast && s.enhancedContrast)}
      />
      <div data-testid="testimonials-container" className={styles.testimonials__container}>
        {window.post_template.checkout_v6_testimonials.checkout_v6_testimonials_reviews &&
          window.post_template.checkout_v6_testimonials.checkout_v6_testimonials_reviews.map((testimonial, index) => (
            <TestimonialsCard testimonial={testimonial} key={index} />
          ))}
      </div>
    </>
  );
};

export default TestimonialsList;
